/**
 * Utility functions for transforming roles between array and string formats
 */

/**
 * Converts an array of roles to a comma-separated string
 * @param {string[]} rolesArray - Array of role strings
 * @returns {string} - Comma-separated string of roles
 */
export const rolesToString = (rolesArray) => {
	if (!Array.isArray(rolesArray) || rolesArray.length === 0) {
		return "";
	}
	return rolesArray.join(",");
};

/**
 * Converts a comma-separated string of roles to an array
 * @param {string} rolesString - Comma-separated string of roles
 * @returns {string[]} - Array of role strings
 */
export const stringToRoles = (rolesString) => {
	if (!rolesString || typeof rolesString !== "string") {
		return [];
	}
	return rolesString
		.split(",")
		.map((role) => role.trim())
		.filter(Boolean);
};
